'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp; /**
                                          * Created by zfc on 2016/9/26.
                                          */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _experienceShop = require('redux/modules/experienceShop');

var experienceShopActions = _interopRequireWildcard(_experienceShop);

var _components = require('components');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExperienceShopProductDetails = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  deferred: false,
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;
    var params = _ref.params;

    var promises = [];
    promises.push(dispatch(experienceShopActions.getProductDetails(params.productId, params.page)));
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    productDetailsData: state.experienceShop.productDetailsData
  };
}, (0, _extends3.default)({}, experienceShopActions)), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ExperienceShopProductDetails, _Component);

  function ExperienceShopProductDetails() {
    (0, _classCallCheck3.default)(this, ExperienceShopProductDetails);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ExperienceShopProductDetails).call(this));

    _this.state = {
      currentPage: 0
    };
    return _this;
  }

  (0, _createClass3.default)(ExperienceShopProductDetails, [{
    key: 'onPageItemClick',
    value: function onPageItemClick(page) {
      var _props = this.props;
      var getProductDetails = _props.getProductDetails;
      var params = _props.params;

      if (getProductDetails) {
        this.setState({
          currentPage: page
        });
        getProductDetails(page, params.productId);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var productDetailsData = this.props.productDetailsData;
      var currentPage = this.state.currentPage;

      var styles = require('./ExperienceShopProductDetails.scss');
      var productDetailsShow = '';
      var productBuyRecordsShow = '';
      var totalPageNumber = 1;
      if (productDetailsData) {
        var experienceShopProductDetail = productDetailsData.experienceShopProductDetail;
        var experienceShopProductDetailError = productDetailsData.experienceShopProductDetailError;
        var experienceShopProductDetailBuyRecords = productDetailsData.experienceShopProductDetailBuyRecords;
        var experienceShopProductDetailBuyRecordsRecordCount = productDetailsData.experienceShopProductDetailBuyRecordsRecordCount;
        var experienceShopProductDetailBuyRecordsError = productDetailsData.experienceShopProductDetailBuyRecordsError;
        var experienceShopProductDetailBuyRecordsPagesize = productDetailsData.experienceShopProductDetailBuyRecordsPagesize;

        if (experienceShopProductDetailError || experienceShopProductDetailBuyRecordsError) {
          productDetailsShow = _react2.default.createElement(_components.ErrorLabel, { error: experienceShopProductDetailError });
        } else if (experienceShopProductDetail instanceof Array && experienceShopProductDetail.length > 0) {
          productDetailsShow = _react2.default.createElement(
            'div',
            { className: styles.lar_box },
            _react2.default.createElement(
              'h3',
              null,
              _react2.default.createElement(
                'span',
                null,
                experienceShopProductDetail[0].shop
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.lar_atcoi1 },
              _react2.default.createElement('img', { className: styles.img_a1, src: experienceShopProductDetail[0].img, alt: '' }),
              _react2.default.createElement(
                'ul',
                { className: styles.lie_a1 },
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'cite',
                    null,
                    '艺品名称：'
                  ),
                  ' ',
                  experienceShopProductDetail[0].productName
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'cite',
                    null,
                    '所有人：'
                  ),
                  ' ',
                  experienceShopProductDetail[0].owner
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'cite',
                    null,
                    '销售价：'
                  ),
                  ' ',
                  experienceShopProductDetail[0].price
                )
              )
            )
          );
        }

        if (experienceShopProductDetailBuyRecordsError) {
          productBuyRecordsShow = _react2.default.createElement(
            'tr',
            null,
            _react2.default.createElement('td', null),
            _react2.default.createElement(
              'td',
              null,
              'experienceShopProductDetailBuyRecordsError'
            ),
            _react2.default.createElement(
              'td',
              null,
              experienceShopProductDetailBuyRecordsError
            ),
            _react2.default.createElement('td', null)
          );
        } else if (experienceShopProductDetailBuyRecords instanceof Array) {
          productBuyRecordsShow = experienceShopProductDetailBuyRecords.map(function (recorde, index) {
            return _react2.default.createElement(
              'tr',
              { key: 'experienceShopProductDetailBuyRecords' + index },
              _react2.default.createElement(
                'td',
                { className: styles.pt },
                recorde.memberName
              ),
              _react2.default.createElement(
                'td',
                { className: styles.pt },
                recorde.number
              ),
              _react2.default.createElement(
                'td',
                { className: styles.pt },
                recorde.buyTime
              )
            );
          });
          totalPageNumber = parseInt(experienceShopProductDetailBuyRecordsRecordCount / experienceShopProductDetailBuyRecordsPagesize, 10);
          if (experienceShopProductDetailBuyRecordsRecordCount % experienceShopProductDetailBuyRecordsPagesize > 0) {
            ++totalPageNumber;
          }
        }

        return _react2.default.createElement(
          'div',
          { className: styles.component },
          productDetailsShow,
          _react2.default.createElement(
            'div',
            { className: styles.lar_box },
            _react2.default.createElement(
              'h3',
              null,
              _react2.default.createElement(
                'span',
                { className: styles.menu },
                '艺品购买信息'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.lar_atcoi1 },
              _react2.default.createElement(
                'table',
                { className: styles.all_table },
                _react2.default.createElement(
                  'colgroup',
                  null,
                  _react2.default.createElement('col', { width: '25%' }),
                  _react2.default.createElement('col', { width: '25%' }),
                  _react2.default.createElement('col', { width: '25%' }),
                  _react2.default.createElement('col', { width: '25%' })
                ),
                _react2.default.createElement(
                  'thead',
                  null,
                  _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement(
                      'th',
                      null,
                      '会员'
                    ),
                    _react2.default.createElement(
                      'th',
                      null,
                      '购买数量'
                    ),
                    _react2.default.createElement(
                      'th',
                      null,
                      '购买时间'
                    )
                  )
                ),
                _react2.default.createElement(
                  'tbody',
                  null,
                  productBuyRecordsShow
                )
              ),
              totalPageNumber && totalPageNumber > 1 ? _react2.default.createElement(_components.HomePagingBar, { selected: currentPage, totalPageNumber: totalPageNumber,
                onPageItemClick: this.onPageItemClick.bind(this) }) : ''
            )
          )
        );
      }
    }
  }]);
  return ExperienceShopProductDetails;
}(_react.Component), _class2.propTypes = {
  productDetailsData: _react.PropTypes.object,
  getProductDetails: _react.PropTypes.func,
  params: _react.PropTypes.object
}, _temp)) || _class) || _class);
exports.default = ExperienceShopProductDetails;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/ExperienceShopProductDetails/ExperienceShopProductDetails.js
 ** module id = 1476
 ** module chunks = 0
 **/